import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  color: var(--black);
  text-align: center;
  background-color: var(--white);

  height: 100%;
  width: 100%;

  .row-center {
    display: flex;
    align-content: center;
    height: 100%;
  }

  .layout-view {
    padding: 100px 150px 0 150px;

    @media only screen and (max-width: 1024px) {
      padding: 100px 50px 0 50px;

      .ant-row {
        flex-direction: column-reverse;
      }

      .ant-row.row-view {
        flex-direction: column;
      }

      .ant-col-6 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-17 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0 !important;
      }
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
  }

  .row-name {
    @media screen and (max-width: 414px) {
      .ant-col-10 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-14 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
  }

  @media screen and (min-width: 1440px) {
    .row-center {
      padding: 0 10%;
    }
  }
`;

export const Block = styled.div`
  display: block;
  width: 100%;
  height: 100vh;
  white-space: pre-wrap;
  background-image: url(${(props) => props.src && props.src});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;

  padding: 120px 100px 0 100px;

  @media screen and (max-width: 414px) {
    padding: 50px !important;
  }
`;

export const BgTop = styled.div`
  width: 100%;
  height: 100vh;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  background-image: url(${(props) => props.src && props.src});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;

  @media only screen and (max-width: 375px) {
    top: 0 !important;
    background-size: cover !important;
  }

  @media only screen and (max-width: 414px) {
    top: 36%;
  }

  @media only screen and (max-width: 912px) {
    top: 28%;
    background-size: contain;
  }

  @media only screen and (min-width: 390px) and (max-width: 393px) {
    top: 0;
  }

  @media screen and (min-width: 375px) and (max-width: 667px) and (orientation: landscape) {
    top: 0;
    background-size: cover !important;
  }
  @media screen and (min-width: 414px) and (max-width: 896px) and (orientation: landscape) {
    top: 0;
    background-size: cover !important;
  }
`;

export const Float = keyframes`
  0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-15px);
	}
	100% {
		transform: translatey(0px);
	}
`;

export const BlockNext = styled.div`
  /* position: absolute; */
  width: 100%;
  /* margin-top: 10px; */
  /* height: 15%; */
  /* bottom: 0; */

  /* @media screen and (max-width: 414px) {
    height: 30%;
  } */

  @media screen and (min-width: 393px) and (max-width: 851px) and (orientation: landscape) {
    svg {
      height: 50px;
    }
  }
  @media screen and (min-width: 414px) and (max-width: 896px) and (orientation: landscape) {
    svg {
      height: 50px;
    }
  }

  .icon-next {
    /* overflow: hidden; */
    transform: translatey(0px);
    animation: ${Float} 5s ease-in-out infinite;
  }

  @media screen and (max-width: 768px) {
    .icon-next .layout-footer {
      display: grid !important;
    }
  }
`;

export const TitleHome = styled.p`
  font-size: clamp(28px, 10vw, 80px);
  white-space: pre-wrap;
  font-family: "Noto Sans Thai";
  line-height: 130px;
  margin-bottom: 25px;
  width: 99%;

  @media screen and (max-width: 375px) {
    line-height: 44px !important;
  }

  @media screen and (max-width: 414px) {
    line-height: 50px !important;
  }

  @media screen and (max-width: 820px) {
    line-height: 80px;
  }

  @media screen and (min-width: 393px) and (max-width: 851px) and (orientation: landscape) {
    line-height: 46px;
    margin-bottom: 10px;
    font-size: 40px;
  }

  @media screen and (min-width: 414px) and (max-width: 896px) and (orientation: landscape) {
    line-height: 46px;
    margin-bottom: 10px;
    font-size: 42px;
  }

  @media screen and (min-width: 1920px) {
    font-size: 108px;
  }
`;

export const DetailHome = styled.p`
  font-size: clamp(18px, 2.5vw, 30px);
  line-height: 35px;
  font-family: "Noto Sans Thai";

  @media screen and (min-width: 1440px) {
    padding: 0 32%;
  }
`;

export const TextName = styled.p`
  font-family: "Noto Sans Thai";
  text-align: left;
  font-size: clamp(84px, 2.5vw, 100px);
  line-height: 100px;
  margin-bottom: 0;
  position: absolute;
  z-index: 1;
  margin-left: 50px;
  top: 60px;

  @media screen and (max-width: 414px) {
    line-height: 80px;
    top: 30px;
  }

  @media screen and (max-width: 820px) {
    line-height: 80px;
    top: 30px;
  }

  @media screen and (min-width: 1163px) {
    width: 200px;
  }
`;

export const TextDetail = styled.p`
  font-family: "Noto Sans Thai";
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  line-height: 40px;
  margin-bottom: 0;
  padding: 62px 118px;

  @media screen and (max-width: 414px) {
    padding: 34px 50px;
  }

  @media screen and (max-width: 820px) {
    padding: 34px 50px;
  }

  @media screen and (max-width: 912px) {
    padding: 34px 50px;
  }
`;

export const BlockName = styled.div`
  width: 100%;
  height: 100%;
  text-align: left;
  padding: 62px 118px;
  min-height: 200px;

  img {
    position: absolute;
    z-index: 1;
  }

  @media screen and (max-width: 414px) {
    padding: 32px 50px;
  }

  @media screen and (max-width: 820px) {
    padding: 32px 50px;
  }
`;

export const BoxImage = styled.div`
  width: 100%;
  text-align: center;

  p {
    background: #9cedde;
    border-radius: 37px;
    font-family: "Noto Sans Thai";
    /* font-size: clamp(26px, 2.5vw, 35px); */
    font-size: 30px;
    margin: 0;
    cursor: pointer;
    color: var(--black);
    position: relative;
    z-index: 1;
    display: flex;
    width: 220px;
    height: 74px;
    justify-content: center;
    align-items: center;
    box-shadow: #9cedde 0 10px 20px -10px;

    &:hover {
      color: var(--white);
    }
  }

  @media screen and (max-width: 414px) {
    p {
      background: #ea8b49;
      color: var(--white);
      box-shadow: #ea8b49 0 10px 20px -10px;

      width: 176px;
      height: 58px;
      font-size: 22px;
    }
  }

  @media screen and (min-width: 414px) and (max-width: 896px) and (orientation: landscape) {
    p {
      width: 160px;
      height: 48px;
      font-size: 18px;
    }
  }

  img {
    height: 87px;
  }

  @media only screen and (max-width: 414px) {
    img {
      height: 60px;
    }
  }

  .icon-course-structure {
    overflow: hidden;
    transform: translatey(0px);
    animation: ${Float} 6s ease-in-out infinite;
    display: flex;
    justify-content: center;
  }
`;

export const FixBoxLayout = styled.div`
  background-color: ${(props) => (props.bg ? props.bg : "var(--while)")};

  /* margin: 100px -158px 50px -158px;

  @media only screen and (max-width: 414px) {
    margin: 100px -50px 50px -50px !important;
  }

  @media only screen and (max-width: 912px) {
    margin: 100px -80px 50px -80px;
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    margin: 100px -80px 50px -80px !important;
  }

  @media only screen and (max-width: 1024px) {
    margin: 100px -110px 50px -110px;
  } */

  .row-group {
    margin-top: 0 !important;
  }
`;

export const SubHead = styled.p`
  font-family: "Noto Sans Thai";
  text-align: ${(props) => (props.align ? props.align : "left")};
  font-size: clamp(20px, 2.5vw, 24px);
  line-height: 35px;
  margin-left: 30px;
  display: flex;
  margin-top: ${(props) => (props.top ? `${props.top}px` : "auto")};
  margin-bottom: ${(props) => (props.bottom ? `${props.bottom}px` : "32px")};
  ${(props) =>
    props.weight === "bold" &&
    `
     font-weight: 600;
    `}

  @media only screen and (min-width: 1440px) {
    min-height: ${(props) => props.height && `${props.height}px`};
  }

  ${(props) =>
    props.align === "center" &&
    `
     justify-content: center;
    `}

  a {
    font-family: "Noto Sans Thai";
    text-align: left;
    font-size: clamp(20px, 2.5vw, 24px);
    line-height: 35px;
    display: flex;
    color: var(--black);
  }

  img {
    cursor: pointer;
    margin-right: 18px;
    height: 36px;
  }
`;

export const View = styled.p`
  font-family: "Noto Sans Thai";
  line-height: 140px;
  font-size: clamp(80px, 2.5vw, 96px);
  text-align: center;
  margin-bottom: 0;
  padding-bottom: 0;
  /* margin-left: 30px; */

  @media only screen and (min-width: 1400px) {
    font-size: 96px;
    line-height: 120px;
  }
`;
